import APIClient from '@/clients/_helpers/client'
import URLs from '@/clients/_urls'

class ImportCopaniesClient extends APIClient {
  async post(token, data) {
    const payload = {
      data,
      url: URLs.COMPANIES_BATCH,
      method: 'POST',
      headers: {
        Authorization: token,
      },
    }
    try {
      const response = await this.sendRequest(payload)
      return response.data
    } catch (err) {
      throw err.response.data.error
    }
  }
}
export default new ImportCopaniesClient()
